import * as Sentry from "@sentry/vue"

import axios from 'axios'
import { getAppName } from './getAppName'

const AuthAxios = axios.create({
  baseURL: import.meta.env.VITE_APP_API_BASE_URL
})

const getDeviceInfo = async function () {
  if (navigator.userAgentData) {
    const ua = await navigator.userAgentData.getHighEntropyValues(["model", "mobile", "platform", "platformVersion"])
    if (ua.model) {
      return ua
    }
  }
}
const getDeviceHeader = async function (data) {
  /* Possible fields for this header
    model: The device model number (e.g. SM-G650)
    app: The app name (replace x-scantrust-app header)
    lang: The user language
    sdk-version: The version of the SDK (doesn't apply here, there is no SDK)
    os:
    os-version:
  */
  let userAgentData = await getDeviceInfo()

  let header = `app=${getAppName()};`
  if (userAgentData) {
    header += `model=${userAgentData.model};os=${userAgentData.platform};os_version=${userAgentData.platformVersion};`
  } else {
    if (data.device) {
      header += `model=${data.device};`
    }
    if (data.os) {
      header += `os=${data.os};`
    }
    if (data.os_version) {
      header += `os_version=${data.os_version};`
    }
  }

  return header
}

export default {
  async upload (file, appData) {
    const headers = {
      'Content-Type': 'multipart/form-data',
      'x-scantrust-device': await getDeviceHeader(appData),
      'x-scantrust-app-version': __APP_VERSION__
    }

    return new Promise((resolve, reject) => {
      let formData = new FormData()

      formData.append('image', file)

      AuthAxios.post(`scan/photo/`, formData, { headers }).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        console.error(err)
        reject(err)
      })
    })
  },

  async unsuportedScan (data) {
    const params = {
      device: {
        model: data.model,
        os: data.os
      },
      mobile_app_version: __APP_VERSION__,
      extended_id: import.meta.env.VITE_FAKE_URL_REPORT_EXTENDED_ID,
      code_space: import.meta.env.VITE_FAKE_URL_REPORT_CODE_SPACE,
      app: getAppName(),
      location: {
        positioning: (!data.longitude & !data.latitude) ? 0 : 4,
        longitude: data.longitude,
        latitude: data.latitude
      }
    }

    return new Promise((resolve, reject) => {
      AuthAxios.post(`scan/unsupported-phone/`, params).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  }
}
